export default class ContractItemUpdateExchangeConfigurationRequest {
  convertFrom: string;

  constructor(obj: any = {}) {
    this.convertFrom = obj.convertFrom || '';
  }

  public static of(convertFrom: string)
  : ContractItemUpdateExchangeConfigurationRequest {
    return new ContractItemUpdateExchangeConfigurationRequest({ convertFrom });
  }
}
